import { paginationSize } from '../../../constants/constants';
import { FETCH_SFV_VISITS, FETCH_SFV_VISITS_ERROR, FETCH_SFV_VISITS_START, FETCH_SFV_VISITS_SUCCESS, SET_SFV_VISITS_PAGINATION } from "../../actions/groupadmin/submittedForVerificationActions";


const INIT_STATE = {
    submittedForVerification: [],
    loading: false,
    message: '',
    error: '',
    pagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0,
    },
    searchFilter: {
        searchText: "",
        risId: 1,
        mipIds: [],
        modalityIds: [],
    },
    sortConditions: [{ sortBy: "visitStart", dataType: "DATE", sortType: "desc" }]
}

export const submittedForVerificationReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_SFV_VISITS_START:
            return { ...state, error: '', message: '', loading: true }

        case FETCH_SFV_VISITS_SUCCESS:
            return { ...state, error: '', message: '', loading: false, submittedForVerification: action.submittedForVerification.length > 0 ? [...action.submittedForVerification] : [] }

        case SET_SFV_VISITS_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }

        case FETCH_SFV_VISITS_ERROR:
            return { ...state, loading: false, error: '' }
        default:
            return state;
    }
}

export default submittedForVerificationReducer;